export default __webpack_public_path__ + "static/media/youtubeprimera.14fb49cd.svg";